var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 727,
    height: 554,
    viewBox: "0 0 727 554",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2356_3616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.587 59.2968V387.618H239.224V181.261H275.793V99.9514H315.45V140.606H348.93V59.2968H388.587Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.499 62.3848H352.018V99.9514H385.499V62.3848Z",
    fill: "#C4D0F5",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.362 103.039H278.881V140.606H312.362V103.039Z",
    fill: "#C4D0F5",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.499 103.039H352.018V140.606H385.499V103.039Z",
    fill: "#C4D0F5",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.362 143.694H278.881V181.261H312.362V143.694Z",
    fill: "#C4D0F5",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.93 143.694H315.45V181.261H348.93V143.694Z",
    fill: "#C4D0F5",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.499 143.694H352.018V181.261H385.499V143.694Z",
    fill: "#C4D0F5",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.793 184.349H242.312V221.915H275.793V184.349Z",
    fill: "#C4D0F5",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.362 184.349H278.881V221.915H312.362V184.349Z",
    fill: "#C4D0F5",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.93 184.349H315.45V221.915H348.93V184.349Z",
    fill: "#C4D0F5",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.499 184.349H352.018V221.915H385.499V184.349Z",
    fill: "#C4D0F5",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.587 400.284L382.839 404.535L377.091 400.284L371.344 404.535L365.6 400.284L359.856 404.535L354.108 400.284L348.365 404.535L342.621 400.284L336.877 404.535L331.129 400.284L325.385 404.535L319.641 400.284L313.898 404.535L308.154 400.284L302.41 404.535L296.666 400.284L290.918 404.535L285.175 400.284L279.431 404.535L273.687 400.284L267.943 404.535L262.199 400.284L256.456 404.535L250.712 400.284L244.968 404.535L239.224 400.284V387.618H388.587V400.284Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.587 218.56H239.224V387.622H388.587V218.56Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.224 204.566L205.19 230.645L239.224 264.459V232.935L363.097 203.132L239.224 204.566Z",
    fill: "white",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.053 225.038L388.587 240.769V270.859L412.1 233.796L363.097 203.132L272.053 225.038Z",
    fill: "#F9F8ED",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.224 232.935L221.262 229.325",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.004 216.647L388.587 240.769",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.224 379.002H269.196",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.663 379.002H388.587",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.535 290.834L192.712 280.893L240.538 358.725C240.968 359.424 241.256 360.201 241.385 361.012C241.514 361.822 241.483 362.65 241.292 363.449C241.102 364.247 240.756 365 240.274 365.665C239.792 366.33 239.184 366.893 238.485 367.323L232.955 370.721C232.256 371.15 231.479 371.438 230.668 371.567C229.858 371.697 229.03 371.665 228.231 371.475C227.433 371.284 226.68 370.938 226.015 370.456C225.35 369.975 224.787 369.367 224.357 368.667L176.531 290.836L176.535 290.834Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.483 268.145L155.766 303.617L125.837 250.878L111.56 225.734C107.703 218.948 106.634 210.93 108.578 203.371C110.522 195.812 115.327 189.304 121.979 185.221L123.126 184.514C129.77 180.428 137.741 179.082 145.359 180.758C152.976 182.434 159.645 187.002 163.961 193.499L179.959 217.609L196.719 242.875L213.483 268.145Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.483 268.152L155.766 303.617L140.801 277.248L196.719 242.891L213.483 268.152Z",
    fill: "#CAD8E5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.719 242.891L140.801 277.247L125.841 250.878L179.959 217.625L196.719 242.891Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.285 324.742L191.565 351.182L188.968 369.655L183.306 409.866L181.586 422.1L174.852 470.007H105.942L99.2078 422.1L97.487 409.866L91.8296 369.655L89.2288 351.182L85.5083 324.742H195.285Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.484 316.645H77.313V324.742H203.484V316.645Z",
    fill: "#9AACD8",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8082 308.398H189.989C191.394 308.398 192.741 308.956 193.734 309.95C194.727 310.943 195.285 312.29 195.285 313.694V316.641H85.5083V313.694C85.5083 312.999 85.6454 312.31 85.9118 311.667C86.1782 311.024 86.5686 310.44 87.0608 309.948C87.553 309.456 88.1373 309.066 88.7803 308.8C89.4233 308.535 90.1124 308.398 90.8082 308.398Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2288 351.182L91.8257 369.655L95.0119 392.293L97.487 409.866H183.306L188.39 373.722L188.964 369.655L191.565 351.182H89.2288Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.012 392.293L97.4871 409.87H183.306L188.39 373.726C186.436 372.62 184.402 371.663 182.305 370.861C176.058 368.551 169.198 367.451 162.692 368.897C156.186 370.343 150.12 374.578 147.512 380.707C146.478 383.139 145.94 385.916 144.031 387.751C140.97 390.702 135.816 389.822 132.178 387.61C128.54 385.398 125.585 382.109 121.72 380.326C117.854 378.542 112.361 378.951 110.448 382.754C109.482 384.675 109.682 386.942 109.615 389.091C109.548 391.24 109.034 393.64 107.23 394.807C104.48 396.571 101.039 394.414 98.0214 393.177C97.0521 392.777 96.0434 392.481 95.012 392.293Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.198 361.338H205.146V470.007H289.198V361.338Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.908 470.007H289.202V361.338L313.057 325.991L336.908 361.338V470.007Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.319 325.991L205.146 361.338H289.202L313.057 325.991H231.319Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.057 308.76H231.32V325.991H313.057V308.76Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.381 324.581C254.467 324.535 252.564 324.878 250.787 325.59C249.01 326.301 247.396 327.366 246.042 328.719C244.688 330.073 243.624 331.687 242.912 333.464C242.201 335.242 241.858 337.145 241.904 339.058L242.135 344.81L246.037 348.711C248.707 351.27 252.274 352.681 255.972 352.641C259.671 352.601 263.207 351.115 265.822 348.499C268.437 345.884 269.924 342.348 269.964 338.65C270.003 334.952 268.593 331.385 266.034 328.714L262.133 324.813L256.381 324.581Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.122 348.951C259.931 348.951 266.262 342.62 266.262 334.811C266.262 327.002 259.931 320.672 252.122 320.672C244.313 320.672 237.983 327.002 237.983 334.811C237.983 342.62 244.313 348.951 252.122 348.951Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.122 340.327C255.169 340.327 257.638 337.858 257.638 334.811C257.638 331.765 255.169 329.295 252.122 329.295C249.076 329.295 246.606 331.765 246.606 334.811C246.606 337.858 249.076 340.327 252.122 340.327Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.047 326.2H298.996V470.007H383.047V326.2Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.758 470.007H383.047V326.2L406.903 290.853L430.758 326.2V470.007Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.165 290.853L298.996 326.2H383.047L406.903 290.853H325.165Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.903 273.621H325.165V290.853H406.903V273.621Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.219 289.446C348.305 289.397 346.4 289.738 344.622 290.448C342.844 291.158 341.228 292.222 339.874 293.576C338.52 294.93 337.455 296.545 336.745 298.323C336.034 300.101 335.693 302.005 335.741 303.92L335.973 309.671L339.875 313.573C341.175 314.941 342.736 316.035 344.466 316.791C346.196 317.547 348.06 317.948 349.948 317.972C351.835 317.996 353.709 317.642 355.457 316.931C357.206 316.219 358.794 315.165 360.129 313.83C361.464 312.495 362.518 310.906 363.229 309.157C363.94 307.409 364.294 305.535 364.27 303.648C364.245 301.76 363.843 299.896 363.087 298.166C362.331 296.436 361.237 294.875 359.868 293.575L355.967 289.678L350.219 289.446Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.972 313.812C353.781 313.812 360.111 307.482 360.111 299.673C360.111 291.864 353.781 285.533 345.972 285.533C338.163 285.533 331.832 291.864 331.832 299.673C331.832 307.482 338.163 313.812 345.972 313.812Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.972 305.189C349.018 305.189 351.488 302.719 351.488 299.673C351.488 296.626 349.018 294.157 345.972 294.157C342.926 294.157 340.456 296.626 340.456 299.673C340.456 302.719 342.926 305.189 345.972 305.189Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.308 230.751H394.256V470.007H478.308V230.751Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.018 470.007H478.308V230.751L502.163 195.404L526.018 230.751V470.007Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.425 195.404L394.256 230.751H478.308L502.163 195.404H420.425Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.163 178.173H420.425V195.404H502.163V178.173Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.479 193.994C443.565 193.948 441.662 194.291 439.885 195.002C438.108 195.714 436.494 196.779 435.14 198.132C433.787 199.486 432.722 201.1 432.01 202.877C431.299 204.654 430.956 206.557 431.002 208.471L431.233 214.223L435.135 218.124C437.809 220.664 441.37 222.059 445.058 222.012C448.746 221.964 452.269 220.478 454.877 217.869C457.485 215.261 458.971 211.737 459.018 208.049C459.064 204.361 457.669 200.8 455.128 198.127L451.227 194.225L445.479 193.994Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.232 218.364C449.041 218.364 455.372 212.033 455.372 204.224C455.372 196.415 449.041 190.085 441.232 190.085C433.423 190.085 427.093 196.415 427.093 204.224C427.093 212.033 433.423 218.364 441.232 218.364Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.232 209.74C444.278 209.74 446.748 207.27 446.748 204.224C446.748 201.178 444.278 198.708 441.232 198.708C438.186 198.708 435.716 201.178 435.716 204.224C435.716 207.27 438.186 209.74 441.232 209.74Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.821 326.2H490.77V470.007H574.821V326.2Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.532 470.007H574.821V326.2L598.676 290.853L622.532 326.2V470.007Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.943 290.853L490.77 326.2H574.821L598.676 290.853H516.943Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.68 273.621H516.943V290.853H598.68V273.621Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 289.446C540.086 289.397 538.182 289.738 536.403 290.448C534.625 291.158 533.01 292.222 531.655 293.576C530.301 294.93 529.236 296.545 528.526 298.323C527.816 300.101 527.474 302.005 527.523 303.92L527.755 309.671L531.656 313.573C532.956 314.941 534.518 316.035 536.248 316.791C537.978 317.547 539.841 317.948 541.729 317.972C543.617 317.996 545.49 317.642 547.239 316.931C548.987 316.219 550.576 315.165 551.911 313.83C553.245 312.495 554.299 310.906 555.01 309.157C555.722 307.409 556.075 305.535 556.051 303.648C556.027 301.76 555.625 299.896 554.869 298.166C554.113 296.436 553.018 294.875 551.649 293.575L547.752 289.678L542 289.446Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.745 313.812C545.555 313.812 551.885 307.482 551.885 299.673C551.885 291.864 545.555 285.533 537.745 285.533C529.936 285.533 523.606 291.864 523.606 299.673C523.606 307.482 529.936 313.812 537.745 313.812Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.745 305.189C540.792 305.189 543.261 302.719 543.261 299.673C543.261 296.626 540.792 294.157 537.745 294.157C534.699 294.157 532.229 296.626 532.229 299.673C532.229 302.719 534.699 305.189 537.745 305.189Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.208 453.055C268.784 453.055 278.979 442.86 278.979 430.284C278.979 417.708 268.784 407.513 256.208 407.513C243.632 407.513 233.437 417.708 233.437 430.284C233.437 442.86 243.632 453.055 256.208 453.055Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.234 457.746C248.385 457.746 258.235 447.895 258.235 435.745C258.235 423.594 248.385 413.744 236.234 413.744C224.084 413.744 214.233 423.594 214.233 435.745C214.233 447.895 224.084 457.746 236.234 457.746Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.746 407.104C269.432 408.971 266.721 410.282 263.821 410.937C260.921 411.591 257.909 411.572 255.018 410.88C254.952 407.906 255.569 404.957 256.822 402.26C258.076 399.563 259.932 397.189 262.247 395.322C264.562 393.455 267.275 392.144 270.177 391.491C273.078 390.838 276.091 390.859 278.983 391.554C279.048 394.527 278.43 397.476 277.175 400.172C275.92 402.868 274.063 405.24 271.746 407.104Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.746 407.104C269.432 408.971 266.721 410.282 263.821 410.937C260.921 411.591 257.909 411.572 255.018 410.88C254.952 407.906 255.569 404.957 256.822 402.26C258.076 399.563 259.932 397.189 262.247 395.322C264.562 393.455 267.275 392.144 270.177 391.491C273.078 390.838 276.091 390.859 278.983 391.554C279.048 394.527 278.43 397.476 277.175 400.172C275.92 402.868 274.063 405.24 271.746 407.104Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.018 410.876L278.979 391.554",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.794 413.657C224.984 415.425 227.55 416.666 230.295 417.286C233.04 417.906 235.89 417.887 238.627 417.232C238.688 414.419 238.103 411.629 236.917 409.077C235.731 406.526 233.975 404.28 231.784 402.514C229.594 400.747 227.027 399.507 224.282 398.888C221.537 398.269 218.687 398.288 215.95 398.944C215.888 401.757 216.473 404.546 217.659 407.097C218.846 409.648 220.603 411.893 222.794 413.657Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.794 413.657C224.984 415.425 227.55 416.666 230.295 417.286C233.04 417.906 235.89 417.887 238.627 417.232C238.688 414.419 238.103 411.629 236.917 409.077C235.731 406.526 233.975 404.28 231.784 402.514C229.594 400.747 227.027 399.507 224.282 398.888C221.537 398.269 218.687 398.288 215.95 398.944C215.888 401.757 216.473 404.546 217.659 407.097C218.846 409.648 220.603 411.893 222.794 413.657Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.627 417.228L215.95 398.94",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.624 453.055C363.2 453.055 373.394 442.86 373.394 430.284C373.394 417.708 363.2 407.513 350.624 407.513C338.047 407.513 327.853 417.708 327.853 430.284C327.853 442.86 338.047 453.055 350.624 453.055Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.65 457.746C342.801 457.746 352.651 447.895 352.651 435.745C352.651 423.594 342.801 413.744 330.65 413.744C318.499 413.744 308.649 423.594 308.649 435.745C308.649 447.895 318.499 457.746 330.65 457.746Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.162 407.104C363.848 408.971 361.136 410.282 358.236 410.937C355.336 411.591 352.325 411.572 349.433 410.88C349.367 407.906 349.985 404.957 351.238 402.26C352.491 399.563 354.347 397.189 356.662 395.322C358.977 393.455 361.69 392.144 364.592 391.491C367.494 390.838 370.506 390.859 373.398 391.554C373.464 394.527 372.845 397.476 371.591 400.172C370.336 402.868 368.478 405.24 366.162 407.104Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.162 407.104C363.848 408.971 361.136 410.282 358.236 410.937C355.336 411.591 352.325 411.572 349.433 410.88C349.367 407.906 349.985 404.957 351.238 402.26C352.491 399.563 354.347 397.189 356.662 395.322C358.977 393.455 361.69 392.144 364.592 391.491C367.494 390.838 370.506 390.859 373.398 391.554C373.464 394.527 372.845 397.476 371.591 400.172C370.336 402.868 368.478 405.24 366.162 407.104Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.433 410.876L373.394 391.554",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.21 413.657C319.399 415.425 321.965 416.666 324.71 417.286C327.455 417.906 330.306 417.887 333.043 417.232C333.104 414.419 332.519 411.629 331.332 409.077C330.146 406.526 328.39 404.28 326.2 402.514C324.009 400.747 321.443 399.507 318.698 398.888C315.953 398.269 313.102 398.288 310.366 398.944C310.304 401.757 310.889 404.546 312.076 407.097C313.263 409.648 315.019 411.892 317.21 413.657Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.21 413.657C319.399 415.425 321.965 416.666 324.71 417.286C327.455 417.906 330.306 417.887 333.043 417.232C333.104 414.419 332.519 411.629 331.332 409.077C330.146 406.526 328.39 404.28 326.2 402.514C324.009 400.747 321.443 399.507 318.698 398.888C315.953 398.269 313.102 398.288 310.366 398.944C310.304 401.757 310.889 404.546 312.076 407.097C313.263 409.648 315.019 411.892 317.21 413.657Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.042 417.228L310.366 398.94",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.884 453.055C458.46 453.055 468.655 442.86 468.655 430.284C468.655 417.708 458.46 407.513 445.884 407.513C433.308 407.513 423.113 417.708 423.113 430.284C423.113 442.86 433.308 453.055 445.884 453.055Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.91 457.746C438.061 457.746 447.911 447.895 447.911 435.745C447.911 423.594 438.061 413.744 425.91 413.744C413.759 413.744 403.909 423.594 403.909 435.745C403.909 447.895 413.759 457.746 425.91 457.746Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.422 407.104C459.108 408.971 456.397 410.282 453.496 410.937C450.596 411.591 447.585 411.572 444.693 410.88C444.628 407.906 445.246 404.958 446.5 402.261C447.753 399.564 449.609 397.191 451.924 395.324C454.239 393.457 456.952 392.147 459.853 391.493C462.754 390.839 465.767 390.86 468.659 391.554C468.723 394.527 468.104 397.475 466.849 400.171C465.594 402.867 463.738 405.239 461.422 407.104Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.422 407.104C459.108 408.971 456.397 410.282 453.496 410.937C450.596 411.591 447.585 411.572 444.693 410.88C444.628 407.906 445.246 404.958 446.5 402.261C447.753 399.564 449.609 397.191 451.924 395.324C454.239 393.457 456.952 392.147 459.853 391.493C462.754 390.839 465.767 390.86 468.659 391.554C468.723 394.527 468.104 397.475 466.849 400.171C465.594 402.867 463.738 405.239 461.422 407.104Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.693 410.876L468.655 391.554",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.474 413.657C414.662 415.425 417.228 416.667 419.972 417.286C422.716 417.906 425.566 417.888 428.303 417.232C428.365 414.419 427.78 411.629 426.594 409.076C425.408 406.524 423.652 404.279 421.461 402.512C419.271 400.745 416.704 399.505 413.959 398.886C411.213 398.268 408.362 398.288 405.626 398.944C405.564 401.757 406.15 404.547 407.337 407.098C408.524 409.649 410.282 411.893 412.474 413.657Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.474 413.657C414.662 415.425 417.228 416.667 419.972 417.286C422.716 417.906 425.566 417.888 428.303 417.232C428.365 414.419 427.78 411.629 426.594 409.076C425.408 406.524 423.652 404.279 421.461 402.512C419.271 400.745 416.704 399.505 413.959 398.886C411.213 398.268 408.362 398.288 405.626 398.944C405.564 401.757 406.15 404.547 407.337 407.098C408.524 409.649 410.282 411.893 412.474 413.657Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.303 417.228L405.626 398.94",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.831 453.055C554.407 453.055 564.602 442.86 564.602 430.284C564.602 417.708 554.407 407.513 541.831 407.513C529.255 407.513 519.06 417.708 519.06 430.284C519.06 442.86 529.255 453.055 541.831 453.055Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.854 457.746C534.005 457.746 543.855 447.895 543.855 435.745C543.855 423.594 534.005 413.744 521.854 413.744C509.703 413.744 499.853 423.594 499.853 435.745C499.853 447.895 509.703 457.746 521.854 457.746Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.366 407.104C555.052 408.971 552.342 410.282 549.442 410.937C546.543 411.591 543.532 411.572 540.641 410.88C540.575 407.906 541.192 404.957 542.446 402.26C543.699 399.563 545.555 397.189 547.87 395.322C550.185 393.455 552.898 392.144 555.8 391.491C558.701 390.838 561.714 390.859 564.606 391.554C564.671 394.527 564.052 397.476 562.796 400.172C561.541 402.868 559.683 405.24 557.366 407.104Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.366 407.104C555.052 408.971 552.342 410.282 549.442 410.937C546.543 411.591 543.532 411.572 540.641 410.88C540.575 407.906 541.192 404.957 542.446 402.26C543.699 399.563 545.555 397.189 547.87 395.322C550.185 393.455 552.898 392.144 555.8 391.491C558.701 390.838 561.714 390.859 564.606 391.554C564.671 394.527 564.052 397.476 562.796 400.172C561.541 402.868 559.683 405.24 557.366 407.104Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.641 410.876L564.598 391.554",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.417 413.657C510.607 415.425 513.173 416.667 515.918 417.287C518.663 417.907 521.513 417.888 524.25 417.232C524.311 414.419 523.726 411.629 522.54 409.077C521.354 406.526 519.598 404.28 517.408 402.514C515.217 400.747 512.651 399.507 509.906 398.888C507.16 398.269 504.31 398.288 501.573 398.944C501.511 401.757 502.096 404.546 503.282 407.097C504.469 409.648 506.226 411.893 508.417 413.657Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.417 413.657C510.607 415.425 513.173 416.667 515.918 417.287C518.663 417.907 521.513 417.888 524.25 417.232C524.311 414.419 523.726 411.629 522.54 409.077C521.354 406.526 519.598 404.28 517.408 402.514C515.217 400.747 512.651 399.507 509.906 398.888C507.16 398.269 504.31 398.288 501.573 398.944C501.511 401.757 502.096 404.546 503.282 407.097C504.469 409.648 506.226 411.893 508.417 413.657Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.25 417.228L501.574 398.94",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.361 354.054L630.845 363.725L607.778 398.274C607.322 398.957 606.736 399.543 606.054 399.999C605.371 400.455 604.606 400.773 603.801 400.933C602.996 401.094 602.167 401.094 601.362 400.934C600.557 400.774 599.791 400.457 599.108 400.002L595.031 397.279C594.348 396.823 593.762 396.237 593.306 395.555C592.849 394.873 592.532 394.107 592.371 393.302C592.211 392.497 592.211 391.668 592.371 390.863C592.53 390.058 592.847 389.292 593.303 388.61L616.371 354.06L616.361 354.054Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.377 376.146L597.737 341.663L630.193 296.542L645.68 275.012C649.855 269.207 656.121 265.249 663.157 263.975C670.193 262.7 677.45 264.208 683.396 268.18L684.425 268.868C690.371 272.838 694.544 278.962 696.063 285.949C697.582 292.935 696.33 300.239 692.569 306.32L678.618 328.875L663.999 352.51L649.377 376.146Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.377 376.142L597.737 341.663L613.967 319.104L663.995 352.51L649.377 376.142Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.995 352.51L613.967 319.104L630.193 296.542L678.614 328.875L663.995 352.51Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.196 22.4453L250.853 36.0227C243.813 42.6874 243.508 53.7969 250.172 60.8365C256.836 67.876 267.945 68.1799 274.985 61.5152L289.328 47.9379C296.368 41.2731 296.674 30.1636 290.01 23.1241C283.346 16.0845 272.236 15.7806 265.196 22.4453Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.319 60.9861L249.753 81.6356C249.746 81.9471 249.646 82.2495 249.467 82.5043C249.287 82.759 249.036 82.9546 248.745 83.0662C248.454 83.1778 248.136 83.2004 247.832 83.131C247.529 83.0617 247.252 82.9035 247.038 82.6767L228.334 62.9151C228.119 62.69 227.976 62.4061 227.922 62.0994C227.869 61.7928 227.908 61.4773 228.034 61.1928C228.161 60.9083 228.368 60.6677 228.632 60.5015C228.895 60.3354 229.201 60.251 229.512 60.2593L250.319 60.9861Z",
    fill: "#CAD8E5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 60.825L242.56 77.9426",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.276 68.1364L250.17 60.825",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.007 23.1131L290.573 2.45969C290.581 2.14844 290.681 1.84659 290.861 1.59244C291.041 1.33828 291.292 1.14328 291.583 1.03216C291.874 0.92104 292.191 0.898817 292.495 0.968313C292.798 1.03781 293.074 1.19589 293.288 1.4225L311.992 21.1841C312.206 21.4094 312.348 21.6929 312.4 21.9989C312.453 22.3048 312.414 22.6195 312.288 22.9032C312.161 23.1868 311.954 23.4268 311.692 23.5928C311.43 23.7588 311.124 23.8434 310.814 23.836L290.007 23.1131Z",
    fill: "#CAD8E5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.156 23.2702L297.766 6.15271",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.05 15.9588L290.156 23.2702",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.17 60.825L267.055 20.8973",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.165 65.791L284.688 19.2708",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.023 51.0543L293.665 28.9237",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.653 109.496L410.175 97.2287C402.578 91.2069 391.538 92.4837 385.517 100.08C379.495 107.677 380.773 118.717 388.371 124.739L403.849 137.006C411.446 143.028 422.486 141.751 428.508 134.155C434.529 126.558 433.251 115.518 425.653 109.496Z",
    fill: "#F9F8ED",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.342 100.274L364.818 102.631C364.509 102.667 364.196 102.611 363.919 102.469C363.642 102.328 363.413 102.107 363.262 101.835C363.11 101.563 363.043 101.253 363.068 100.942C363.093 100.632 363.21 100.337 363.404 100.093L380.297 78.7676C380.491 78.5234 380.753 78.3424 381.05 78.2476C381.347 78.1528 381.666 78.1485 381.966 78.2353C382.265 78.322 382.532 78.4959 382.732 78.7349C382.933 78.9738 383.057 79.2669 383.091 79.5769L385.342 100.274Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.475 100.105L367.45 95.0011",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.838 84.4211L385.475 100.105",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.46 134.175L448.983 131.817C449.293 131.781 449.605 131.837 449.882 131.979C450.16 132.121 450.388 132.341 450.54 132.613C450.691 132.885 450.759 133.196 450.733 133.506C450.708 133.816 450.591 134.112 450.398 134.355L433.504 155.681C433.311 155.926 433.048 156.108 432.751 156.204C432.453 156.3 432.134 156.304 431.833 156.217C431.533 156.131 431.265 155.956 431.065 155.716C430.864 155.476 430.739 155.182 430.707 154.871L428.46 134.175Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.33 134.351L446.355 139.455",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.963 150.035L428.33 134.351",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.475 100.105L427.399 111.148",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.977 117.635L431.512 128.368",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.24 134.206L423.231 138.626",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.665 479.853H726.109V456.461H521.665V479.853Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.665 503.24H726.109V479.849H521.665V503.24Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.665 526.632H726.109V503.24H521.665V526.632Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.665 550.024H726.109V526.632H521.665V550.024Z",
    fill: "#1D1D1B",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.034 399.899L521.665 456.461H726.109L567.034 399.899Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.043 448.658C621.718 448.658 623.887 446.49 623.887 443.814C623.887 441.139 621.718 438.97 619.043 438.97C616.367 438.97 614.199 441.139 614.199 443.814C614.199 446.49 616.367 448.658 619.043 448.658Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.544 434.645C589.22 434.645 591.388 432.476 591.388 429.8C591.388 427.125 589.22 424.956 586.544 424.956C583.869 424.956 581.7 427.125 581.7 429.8C581.7 432.476 583.869 434.645 586.544 434.645Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.271 434.645C651.946 434.645 654.115 432.476 654.115 429.8C654.115 427.125 651.946 424.956 649.271 424.956C646.595 424.956 644.426 427.125 644.426 429.8C644.426 432.476 646.595 434.645 649.271 434.645Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.043 422.678C621.718 422.678 623.887 420.509 623.887 417.834C623.887 415.158 621.718 412.989 619.043 412.989C616.367 412.989 614.199 415.158 614.199 417.834C614.199 420.509 616.367 422.678 619.043 422.678Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.077 448.658C558.752 448.658 560.921 446.49 560.921 443.814C560.921 441.139 558.752 438.97 556.077 438.97C553.402 438.97 551.233 441.139 551.233 443.814C551.233 446.49 553.402 448.658 556.077 448.658Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.085 409.677C582.761 409.677 584.93 407.509 584.93 404.833C584.93 402.158 582.761 399.989 580.085 399.989C577.41 399.989 575.241 402.158 575.241 404.833C575.241 407.509 577.41 409.677 580.085 409.677Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.145 448.658C679.82 448.658 681.989 446.49 681.989 443.814C681.989 441.139 679.82 438.97 677.145 438.97C674.47 438.97 672.301 441.139 672.301 443.814C672.301 446.49 674.47 448.658 677.145 448.658Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.982 479.853H607.426V456.461H402.982V479.853Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.982 503.24H607.426V479.849H402.982V503.24Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.982 526.632H607.426V503.24H402.982V526.632Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.982 550.024H607.426V526.632H402.982V550.024Z",
    fill: "#1D1D1B",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.347 399.899L402.982 456.461H607.426L448.347 399.899Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.36 448.658C503.035 448.658 505.204 446.49 505.204 443.814C505.204 441.139 503.035 438.97 500.36 438.97C497.684 438.97 495.515 441.139 495.515 443.814C495.515 446.49 497.684 448.658 500.36 448.658Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.861 434.645C470.536 434.645 472.705 432.476 472.705 429.8C472.705 427.125 470.536 424.956 467.861 424.956C465.186 424.956 463.017 427.125 463.017 429.8C463.017 432.476 465.186 434.645 467.861 434.645Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.587 434.645C533.263 434.645 535.431 432.476 535.431 429.8C535.431 427.125 533.263 424.956 530.587 424.956C527.912 424.956 525.743 427.125 525.743 429.8C525.743 432.476 527.912 434.645 530.587 434.645Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.36 422.678C503.035 422.678 505.204 420.509 505.204 417.834C505.204 415.158 503.035 412.989 500.36 412.989C497.684 412.989 495.515 415.158 495.515 417.834C495.515 420.509 497.684 422.678 500.36 422.678Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.394 448.658C440.069 448.658 442.238 446.49 442.238 443.814C442.238 441.139 440.069 438.97 437.394 438.97C434.718 438.97 432.55 441.139 432.55 443.814C432.55 446.49 434.718 448.658 437.394 448.658Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.402 409.677C464.078 409.677 466.246 407.509 466.246 404.833C466.246 402.158 464.078 399.989 461.402 399.989C458.727 399.989 456.558 402.158 456.558 404.833C456.558 407.509 458.727 409.677 461.402 409.677Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.462 448.658C561.137 448.658 563.306 446.49 563.306 443.814C563.306 441.139 561.137 438.97 558.462 438.97C555.786 438.97 553.618 441.139 553.618 443.814C553.618 446.49 555.786 448.658 558.462 448.658Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4771 450.297C40.4771 505.378 81.7052 550.028 132.567 550.028C183.428 550.028 224.652 505.378 224.652 450.297C224.652 449.951 224.652 449.613 224.652 449.279H40.4849C40.477 449.613 40.4771 449.951 40.4771 450.297Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.652 449.26C224.652 450.949 222.971 452.579 219.855 454.104C217.146 455.358 214.326 456.358 211.432 457.093C195.324 461.486 166.02 464.428 132.567 464.428C99.1135 464.428 69.8208 461.486 53.7012 457.093C50.8071 456.359 47.9873 455.358 45.278 454.104C42.1586 452.579 40.4771 450.961 40.4771 449.26C40.4771 440.883 81.7288 434.099 132.567 434.099C183.405 434.099 224.652 440.899 224.652 449.26Z",
    fill: "#C4D0F5",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.215 463.521L129.876 455.868L18.1423 337.856C17.2437 336.87 16.1543 336.076 14.9401 335.523C13.726 334.97 12.4122 334.669 11.0783 334.638C9.74441 334.607 8.41813 334.847 7.17968 335.344C5.94123 335.84 4.81635 336.582 3.87309 337.526C2.92959 338.47 2.18718 339.595 1.69068 340.833C1.19418 342.072 0.95391 343.398 0.984387 344.732C1.01486 346.066 1.31546 347.38 1.86801 348.595C2.42055 349.81 3.21357 350.9 4.19917 351.799L122.215 463.521Z",
    fill: "white",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.302 452.795C174.299 456.284 175.603 459.648 177.955 462.224C178.014 462.291 178.081 462.358 178.136 462.425C182.996 461.953 187.565 461.427 191.808 460.853C194.951 460.408 197.91 459.937 200.683 459.439C201.696 457.545 202.261 455.444 202.335 453.298C202.408 451.151 201.987 449.017 201.106 447.058C200.224 445.1 198.905 443.37 197.249 442.002C195.594 440.633 193.646 439.664 191.557 439.167C190.503 438.91 189.423 438.778 188.339 438.774C186.207 438.77 184.103 439.255 182.188 440.192C180.273 441.128 178.598 442.491 177.292 444.176C176.02 445.791 175.126 447.67 174.675 449.676C174.524 450.313 174.426 450.96 174.38 451.613C174.37 451.647 174.37 451.684 174.38 451.719C174.317 452.08 174.302 452.442 174.302 452.795Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.947 452.807C176.689 452.807 182.965 446.531 182.965 438.789C182.965 431.048 176.689 424.772 168.947 424.772C161.205 424.772 154.929 431.048 154.929 438.789C154.929 446.531 161.205 452.807 168.947 452.807Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.987 461.046C149.983 461.632 150.021 462.217 150.101 462.798C150.153 463.252 150.231 463.704 150.333 464.149C152.332 464.083 154.308 464 156.249 463.918C158.887 463.8 161.472 463.669 164.005 463.525C168.853 463.23 173.512 462.877 177.94 462.456C177.944 462.384 177.944 462.312 177.94 462.24C177.981 461.849 178.001 461.455 177.999 461.061C178.003 457.604 176.724 454.267 174.408 451.699C174.389 451.674 174.368 451.65 174.345 451.629C173.903 451.132 173.42 450.672 172.903 450.254C170.394 448.176 167.238 447.041 163.981 447.044C163.906 447.04 163.832 447.04 163.757 447.044C161.952 447.062 160.169 447.436 158.508 448.144C156.9 448.834 155.435 449.817 154.187 451.043C152.105 453.073 150.711 455.704 150.203 458.567C150.146 458.852 150.105 459.141 150.081 459.431C150.016 459.967 149.984 460.506 149.987 461.046Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.983 458.578C157.725 458.578 164.001 452.302 164.001 444.561C164.001 436.819 157.725 430.543 149.983 430.543C142.241 430.543 135.965 436.819 135.965 444.561C135.965 452.302 142.241 458.578 149.983 458.578Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.249 435.375C160.771 435.375 164.437 431.71 164.437 427.188C164.437 422.666 160.771 419 156.249 419C151.727 419 148.062 422.666 148.062 427.188C148.062 431.71 151.727 435.375 156.249 435.375Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.485 452.807C134.227 452.807 140.503 446.531 140.503 438.789C140.503 431.048 134.227 424.772 126.485 424.772C118.743 424.772 112.467 431.048 112.467 438.789C112.467 446.531 118.743 452.807 126.485 452.807Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.951 431.796C127.426 431.796 131.863 427.358 131.863 421.884C131.863 416.41 127.426 411.972 121.951 411.972C116.477 411.972 112.039 416.41 112.039 421.884C112.039 427.358 116.477 431.796 121.951 431.796Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.239 458.575C118.239 459.551 118.341 460.526 118.541 461.482C118.747 462.452 119.057 463.398 119.464 464.303C121.704 464.354 123.975 464.385 126.273 464.409C128.237 464.436 130.249 464.444 132.256 464.444H132.484C132.948 464.444 133.4 464.444 133.851 464.444C137.647 464.444 141.379 464.4 145.048 464.311C145.852 462.521 146.27 460.583 146.274 458.622V458.582C146.274 458.41 146.274 458.245 146.274 458.072C146.19 455.747 145.528 453.48 144.348 451.475C143.168 449.47 141.508 447.791 139.517 446.588C139.187 446.382 138.846 446.196 138.495 446.03C137.695 445.623 136.853 445.303 135.985 445.075C134.774 444.734 133.522 444.562 132.264 444.565C131.071 444.564 129.883 444.716 128.728 445.016L128.646 445.04C127.5 445.342 126.398 445.794 125.369 446.384C123.268 447.574 121.509 449.286 120.262 451.353C119.677 452.297 119.211 453.309 118.875 454.367C118.449 455.729 118.235 457.148 118.239 458.575Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.87 463.403C102.976 463.666 107.23 463.89 111.611 464.051C114.188 464.145 116.807 464.225 119.468 464.291C121.708 464.342 123.979 464.373 126.277 464.397C125.946 462.494 125.226 460.681 124.161 459.07C123.096 457.459 121.709 456.086 120.088 455.037C118.466 453.989 116.646 453.286 114.74 452.975C112.834 452.663 110.885 452.749 109.014 453.228C108.155 453.441 107.319 453.74 106.519 454.119C104.383 455.119 102.536 456.645 101.153 458.555C100.196 459.85 99.4774 461.306 99.0311 462.853C98.9637 463.032 98.9098 463.216 98.87 463.403Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.642 463.297C119.384 463.297 125.66 457.021 125.66 449.279C125.66 441.537 119.384 435.261 111.642 435.261C103.901 435.261 97.6246 441.537 97.6246 449.279C97.6246 457.021 103.901 463.297 111.642 463.297Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6285 444.561C105.37 444.561 111.646 438.285 111.646 430.543C111.646 422.801 105.37 416.525 97.6285 416.525C89.8867 416.525 83.6107 422.801 83.6107 430.543C83.6107 438.285 89.8867 444.561 97.6285 444.561Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.281 452.795C126.278 455.096 126.843 457.362 127.925 459.393C129.007 461.423 130.573 463.155 132.484 464.436C132.948 464.436 133.4 464.436 133.851 464.436C137.647 464.436 141.379 464.392 145.048 464.303C146.184 464.271 147.303 464.248 148.423 464.212C149.022 463.794 149.584 463.323 150.101 462.806C150.862 462.076 151.531 461.255 152.093 460.362C153.544 458.108 154.313 455.484 154.308 452.803C154.307 452.215 154.268 451.627 154.191 451.043C153.769 447.694 152.152 444.61 149.637 442.359C147.122 440.108 143.878 438.842 140.503 438.793C140.435 438.789 140.367 438.789 140.299 438.793C139.2 438.794 138.105 438.925 137.038 439.186C133.619 440.005 130.632 442.075 128.666 444.989C128.652 445.005 128.642 445.024 128.634 445.044C127.097 447.337 126.278 450.035 126.281 452.795Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.997 463.301C163.993 463.374 163.993 463.448 163.997 463.521C168.845 463.226 173.504 462.873 177.932 462.452C177.997 462.448 178.063 462.448 178.128 462.452C182.988 461.981 187.557 461.454 191.8 460.881C191.235 457.675 189.569 454.768 187.09 452.658C184.61 450.549 181.473 449.371 178.219 449.326C178.148 449.322 178.077 449.322 178.007 449.326C176.875 449.322 175.747 449.454 174.647 449.719C174.056 449.864 173.475 450.051 172.911 450.281C171.378 450.861 169.962 451.713 168.731 452.795C167.24 454.109 166.047 455.726 165.231 457.537C164.414 459.349 163.994 461.314 163.997 463.301Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.986 446.289C188.823 446.289 192.743 442.369 192.743 437.532C192.743 432.696 188.823 428.775 183.986 428.775C179.15 428.775 175.229 432.696 175.229 437.532C175.229 442.369 179.15 446.289 183.986 446.289Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.338 453.601C199.175 453.601 203.096 449.68 203.096 444.844C203.096 440.007 199.175 436.086 194.338 436.086C189.502 436.086 185.581 440.007 185.581 444.844C185.581 449.68 189.502 453.601 194.338 453.601Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.925 447.032C145.48 447.032 149.983 442.529 149.983 436.974C149.983 431.42 145.48 426.917 139.925 426.917C134.371 426.917 129.868 431.42 129.868 436.974C129.868 442.529 134.371 447.032 139.925 447.032Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.851 434.201C139.406 434.201 143.909 429.698 143.909 424.143C143.909 418.588 139.406 414.085 133.851 414.085C128.297 414.085 123.794 418.588 123.794 424.143C123.794 429.698 128.297 434.201 133.851 434.201Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.299 428.775C110.906 428.775 116.262 423.419 116.262 416.812C116.262 410.205 110.906 404.849 104.299 404.849C97.6925 404.849 92.3364 410.205 92.3364 416.812C92.3364 423.419 97.6925 428.775 104.299 428.775Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4219 459.773C76.5646 459.773 81.5442 454.793 81.5442 448.651C81.5442 442.508 76.5646 437.528 70.4219 437.528C64.2793 437.528 59.2997 442.508 59.2997 448.651C59.2997 454.793 64.2793 459.773 70.4219 459.773Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2171 446.384C80.3598 446.384 85.3394 441.404 85.3394 435.261C85.3394 429.119 80.3598 424.139 74.2171 424.139C68.0745 424.139 63.0948 429.119 63.0948 435.261C63.0948 441.404 68.0745 446.384 74.2171 446.384Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2817 444.844C98.0235 444.844 104.299 438.568 104.299 430.826C104.299 423.084 98.0235 416.808 90.2817 416.808C82.5399 416.808 76.264 423.084 76.264 430.826C76.264 438.568 82.5399 444.844 90.2817 444.844Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.422 452.795C70.416 455.69 71.3143 458.514 72.9914 460.873C76.4211 461.356 80.0631 461.784 83.8897 462.181C86.6791 462.46 89.5589 462.723 92.5329 462.967C92.9647 463.07 93.4031 463.144 93.8451 463.187C93.8904 463.157 93.9313 463.122 93.9669 463.081C96.561 460.692 98.1472 457.405 98.4024 453.888C98.4378 453.534 98.4535 453.169 98.4535 452.807C98.4535 452.191 98.4115 451.575 98.3278 450.965C98.0978 449.173 97.5171 447.444 96.6188 445.877C96.33 445.372 96.0112 444.886 95.6641 444.419C93.4793 441.491 90.2366 439.533 86.628 438.962C86.5455 438.962 86.463 438.939 86.3805 438.931C86.3054 438.914 86.2292 438.903 86.1526 438.895C84.1037 438.639 82.0233 438.841 80.0618 439.486C78.1002 440.132 76.3066 441.205 74.8104 442.628C73.4228 443.933 72.3176 445.508 71.5628 447.257C70.808 449.006 70.4197 450.891 70.422 452.795Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5521 449.283C81.553 452.472 82.641 455.565 84.6367 458.052C86.6323 460.539 89.4162 462.271 92.529 462.963C92.9608 463.066 93.3992 463.14 93.8412 463.183C94.4138 463.264 94.9915 463.303 95.5698 463.301C95.8964 463.304 96.223 463.29 96.5481 463.258C97.3852 463.207 98.2154 463.076 99.0271 462.865C100.671 462.452 102.223 461.737 103.604 460.755C105.496 459.437 107.031 457.67 108.071 455.612C108.46 454.859 108.774 454.069 109.01 453.255C109.394 451.972 109.589 450.639 109.588 449.299C109.592 446.333 108.653 443.444 106.904 441.048C106.112 439.948 105.16 438.972 104.079 438.153C103.922 438.035 103.765 437.913 103.604 437.815C101.523 436.344 99.0756 435.475 96.5323 435.305C96.218 435.281 95.9037 435.269 95.5855 435.269C94.5747 435.271 93.5671 435.382 92.58 435.599C90.9478 435.95 89.3938 436.597 87.9952 437.509C87.3967 437.888 86.8315 438.318 86.3058 438.793C86.2575 438.822 86.2137 438.858 86.1762 438.899C85.6035 439.409 85.0775 439.969 84.6047 440.573C83.7346 441.656 83.035 442.866 82.5303 444.16C81.8863 445.791 81.5544 447.529 81.5521 449.283Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9093 462.189C86.6987 462.468 89.5785 462.731 92.5525 462.975C92.9843 463.078 93.4228 463.152 93.8647 463.195C94.4374 463.276 95.0151 463.315 95.5934 463.313C95.92 463.316 96.2466 463.302 96.5716 463.269C97.3574 463.328 98.1117 463.375 98.8935 463.427C102.999 463.69 107.254 463.914 111.634 464.075C111.627 463.819 111.602 463.565 111.56 463.313C111.232 460.452 110.021 457.764 108.095 455.624C107.613 455.087 107.087 454.592 106.523 454.143C104.209 452.225 101.334 451.112 98.3317 450.972C98.1353 450.972 97.9388 450.972 97.7424 450.972H97.6324C95.0422 450.971 92.5025 451.689 90.2955 453.045C88.0886 454.401 86.3009 456.342 85.1311 458.653C84.5592 459.768 84.1479 460.959 83.9093 462.189Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.851 464.436C137.647 464.436 141.379 464.392 145.048 464.303C146.184 464.271 147.303 464.248 148.423 464.212C149.064 464.189 149.7 464.173 150.333 464.157C152.332 464.091 154.308 464.008 156.249 463.926C155.051 462.391 153.544 461.125 151.826 460.21C150.108 459.295 148.216 458.751 146.274 458.614C145.936 458.59 145.591 458.575 145.245 458.575C143.016 458.573 140.819 459.104 138.837 460.124C136.855 461.143 135.146 462.622 133.851 464.436Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.1 471.477C350.278 534.179 284.134 561.229 242.524 547.109C184.878 527.54 194.723 491.383 194.723 491.383L178.242 472.18L182.564 461.281L193.006 459.47L202.828 482.182C202.828 482.182 214.308 478.533 227.823 489.415C241.126 500.125 285.756 530.946 341.418 462.024C350.396 450.91 361.648 461.631 360.1 471.477Z",
    fill: "#F9F8ED",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.018 459.466L202.824 482.182L194.723 491.383L178.242 472.18L182.576 461.281L193.018 459.466Z",
    fill: "#DBE6F3",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.824 482.182C202.824 482.182 277.4 580.22 352.117 457.647",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.344 477.908C339.344 477.908 362.917 484.83 382.281 503.445C401.646 522.059 409.519 545.329 409.519 545.329C394.665 560.793 373.579 551.293 354.203 532.674C334.826 514.056 324.761 493.089 339.344 477.908Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.528 545.273C417.733 536.733 408.673 514.718 389.294 496.101C369.915 477.484 347.553 469.316 339.349 477.856C331.145 486.397 340.204 508.412 359.584 527.028C378.963 545.645 401.324 553.814 409.528 545.273Z",
    fill: "#F9F8ED",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.29 496.153L386.359 499.206",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.779 523.748L359.848 526.801",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.804 478.073L346.726 484.724",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.412 538.23L409.335 544.881",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.562 524.263L402.593 521.717",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.542 501.237L339.576 498.691",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.394 477.024L363.219 483.883",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.919 539.07L388.744 545.93",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.321 536.686L404.801 531.665",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.334 491.289L336.818 486.268",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.162 484.736L375.045 490.059",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.094 532.895L373.976 538.218",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.845 548.213L395.612 540.897",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.527 482.057L348.294 474.741",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.681 510.391L396.283 510.607",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.855 512.347L347.457 512.563",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.831 507.899C387.91 506.775 386.718 503.879 384.169 501.431C381.621 498.982 378.679 497.908 377.6 499.031C376.521 500.155 377.712 503.051 380.261 505.499C382.81 507.948 385.751 509.022 386.831 507.899Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.769 523.579C372.848 522.455 371.657 519.559 369.108 517.111C366.559 514.662 363.618 513.588 362.538 514.711C361.459 515.835 362.651 518.73 365.2 521.179C367.749 523.628 370.69 524.702 371.769 523.579Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.514 498.656C362.594 497.532 361.402 494.636 358.853 492.188C356.304 489.739 353.363 488.665 352.284 489.788C351.205 490.912 352.396 493.808 354.945 496.256C357.494 498.705 360.435 499.779 361.514 498.656Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.284 518.607C384.062 516.756 382.101 511.986 377.902 507.953C373.704 503.92 368.859 502.151 367.081 504.002C365.303 505.854 367.265 510.624 371.463 514.656C375.661 518.689 380.506 520.458 382.284 518.607Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.088 532.824C398.167 531.701 396.976 528.805 394.427 526.356C391.878 523.908 388.937 522.833 387.857 523.957C386.778 525.08 387.97 527.976 390.519 530.425C393.067 532.873 396.009 533.948 397.088 532.824Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.667 156.176C597.667 156.176 605.744 179.355 601.874 205.961C598.004 232.566 583.645 252.477 583.645 252.477C562.43 249.389 557.884 226.712 561.754 200.118C565.624 173.525 576.836 153.143 597.667 156.176Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.892 207.417C615.762 180.825 609.399 157.885 597.68 156.179C585.96 154.474 573.323 174.649 569.453 201.241C565.583 227.834 571.946 250.774 583.665 252.48C595.384 254.185 608.022 234.01 611.892 207.417Z",
    fill: "#F9F8ED",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.885 207.41L607.697 206.801",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.016 201.902L569.828 201.293",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.8 156.639L596.417 166.143",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.295 242.561L583.912 252.064",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.817 240.251L598.833 233.104",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.879 175.599L580.895 168.453",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.635 172.778L606.695 179.064",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.017 229.639L571.077 235.925",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.316 249.723L592.025 240.687",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.687 168.017L589.397 158.981",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.953 189.275L608.553 192.277",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.159 216.427L568.759 219.428",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.263 247.094L579.17 238.581",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.542 170.123L605.449 161.609",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.512 225.773L604.196 221.507",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.516 187.197L574.2 182.93",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.574 206.353C605.083 202.855 604.246 199.838 602.704 199.613C601.163 199.389 599.5 202.043 598.991 205.54C598.482 209.038 599.319 212.055 600.861 212.28C602.403 212.504 604.065 209.851 604.574 206.353Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.059 203.222C583.568 199.724 582.731 196.707 581.189 196.483C579.648 196.258 577.985 198.912 577.476 202.41C576.967 205.907 577.805 208.925 579.346 209.149C580.888 209.374 582.55 206.72 583.059 203.222Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.368 180.379C597.877 176.881 597.04 173.864 595.498 173.64C593.957 173.415 592.294 176.069 591.785 179.567C591.276 183.064 592.113 186.082 593.655 186.306C595.197 186.531 596.859 183.877 597.368 180.379Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.625 205.049C596.463 199.288 595.083 194.318 592.543 193.949C590.003 193.579 587.264 197.949 586.426 203.71C585.588 209.471 586.967 214.441 589.507 214.81C592.047 215.18 594.786 210.81 595.625 205.049Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.265 229.192C590.774 225.694 589.937 222.677 588.396 222.452C586.854 222.228 585.191 224.882 584.682 228.379C584.173 231.877 585.011 234.894 586.552 235.119C588.094 235.343 589.756 232.69 590.265 229.192Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.846 192.831C141.846 192.831 150.097 169.71 169.827 151.441C189.557 133.173 213.212 126.667 213.212 126.667C227.792 142.382 217.09 162.894 197.383 181.162C177.677 199.431 156.159 208.271 141.846 192.831Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.105 175.507C211.813 157.239 221.263 135.388 213.212 126.703C205.161 118.018 182.658 125.787 162.95 144.056C143.242 162.325 133.793 184.175 141.844 192.86C149.895 201.545 172.397 193.776 192.105 175.507Z",
    fill: "#F9F8ED",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.948 144.024L165.824 147.128",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.964 172.083L191.844 175.187",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.039 192.387L149.079 185.857",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.712 133.354L212.752 126.824",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.181 125.41L189.235 132.218",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.556 186.993L162.61 193.801",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.18 171.765L149.193 169.345",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.598 149.866L212.611 147.446",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.742 123.375L199.296 130.588",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.495 188.623L150.05 195.836",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.733 157.468L156.041 157.896",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.75 161.314L204.058 161.743",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.585 135.495L207.983 140.296",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.808 178.915L139.206 183.716",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.877 132.473L177.783 137.879",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.009 181.331L176.914 186.737",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.812 153.615C174.405 151.212 175.647 148.338 174.588 147.195C173.529 146.053 170.569 147.074 167.977 149.477C165.385 151.88 164.142 154.754 165.201 155.897C166.26 157.039 169.22 156.018 171.812 153.615Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.594 169.557C189.186 167.154 190.429 164.28 189.37 163.137C188.311 161.995 185.351 163.017 182.759 165.42C180.166 167.822 178.924 170.697 179.983 171.839C181.042 172.982 184.002 171.96 186.594 169.557Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.117 178.352C163.709 175.949 164.952 173.075 163.893 171.933C162.834 170.79 159.874 171.812 157.282 174.215C154.689 176.618 153.447 179.492 154.506 180.634C155.565 181.777 158.525 180.755 161.117 178.352Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.444 162.927C184.713 158.969 186.759 154.235 185.014 152.353C183.269 150.47 178.394 152.152 174.124 156.11C169.855 160.068 167.809 164.802 169.554 166.684C171.299 168.567 176.174 166.885 180.444 162.927Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.293 144.819C199.886 142.417 201.128 139.542 200.069 138.4C199.01 137.257 196.05 138.279 193.458 140.682C190.866 143.085 189.623 145.959 190.682 147.102C191.741 148.244 194.701 147.222 197.293 144.819Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.419 307.475C442.419 307.475 449.341 283.903 467.955 264.538C486.57 245.173 509.84 237.3 509.84 237.3C525.303 252.159 515.803 273.24 497.185 292.617C478.567 311.993 457.599 322.063 442.419 307.475Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.581 287.192C510.198 267.812 518.366 245.451 509.826 237.247C501.286 229.043 479.27 238.102 460.654 257.481C442.037 276.861 433.869 299.222 442.409 307.426C450.949 315.63 472.965 306.571 491.581 287.192Z",
    fill: "#F9F8ED",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.668 257.529L463.716 260.46",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.259 284.04L491.312 286.971",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.588 307.019L449.239 300.093",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.74 244.407L509.392 237.485",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.774 237.257L486.228 244.227",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.751 300.278L463.206 307.243",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.535 286.425L448.394 283.604",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.585 260.9L510.445 258.075",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.196 234.499L496.179 242.018",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.8 302.486L450.783 310.001",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.247 271.657L454.574 271.775",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.405 272.726L502.733 272.843",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.723 245.975L505.408 251.208",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.571 293.292L439.256 298.526",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.905 245.138L475.121 250.536",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.858 293.964L477.074 299.362",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.056 266.514C472.505 263.965 473.579 261.024 472.455 259.945C471.332 258.865 468.436 260.057 465.987 262.606C463.539 265.155 462.464 268.096 463.588 269.175C464.711 270.255 467.607 269.063 470.056 266.514Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.732 281.576C488.181 279.027 489.255 276.085 488.131 275.006C487.008 273.927 484.112 275.118 481.663 277.667C479.215 280.216 478.14 283.158 479.264 284.237C480.387 285.316 483.283 284.125 485.732 281.576Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.809 291.83C463.258 289.281 464.332 286.34 463.208 285.261C462.085 284.181 459.189 285.373 456.74 287.922C454.292 290.471 453.218 293.412 454.341 294.491C455.465 295.571 458.36 294.379 460.809 291.83Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.213 275.313C483.246 271.114 485.015 266.269 483.164 264.491C481.313 262.713 476.543 264.675 472.51 268.873C468.477 273.071 466.708 277.916 468.559 279.694C470.41 281.473 475.18 279.511 479.213 275.313Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.981 256.257C497.43 253.708 498.504 250.767 497.381 249.687C496.257 248.608 493.362 249.799 490.913 252.348C488.464 254.897 487.39 257.839 488.514 258.918C489.637 259.997 492.533 258.806 494.981 256.257Z",
    fill: "#FCEFF9",
    stroke: "#050D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2356_3616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 725.913,
    height: 552.931,
    fill: "white",
    transform: "translate(0.588623 0.534607)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame11);
export default __webpack_public_path__ + "static/media/frame-11.1c92fc4d6a599b78356aa55ca29406da.svg";
export { ForwardRef as ReactComponent };